import { selectTopCollectionList } from "@/components/homepage/auction/store/slice";
import { Button, Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useDispatch, useSelector } from "react-redux";
import styles from "./table.module.scss";
import { useEffect, useState } from "react";
import { getTopCollection } from "@/components/homepage/trending/store/thunk";
import { formatNumberToCommas } from "../tables/Collections";
import CollectionsCell from "../tables/CollectionCell";
import { useHistory } from "react-router-dom";
import { routes } from "@/router/constants";
import ReactLoading from "react-loading";

interface DataType {
  key: string;
  id: string;
  collection?: {
    id: string;
    url: string;
    name: string;
    owner: string;
  };
  price?: string;
  volume?: string;
  volChange?: string;
  items?: string;
  owners?: string;
  isFavorite?: boolean | false;
}

const TEXT_OPV = "MBC";
const CELL_HEIGHT = 60;

const TopTable = () => {
  const history = useHistory();

  const dispatch = useDispatch();
  const dataTop = useSelector(selectTopCollectionList);

  const [isPressSeeAll, setIsPressSeeAll] = useState(false);

  useEffect(() => {
    dispatch(getTopCollection("ALL"));
  }, []);

  const convertToInternationalCurrencySystem = (labelValue: any, type: any) => {
    //
    const number =
      Math.abs(Number(labelValue)) >= 1.0e3
        ? `${formatNumberToCommas(
            (Math.abs(Number(labelValue)) / 1.0e3).toFixed(3)
          )} K`
        : Math.abs(Number(labelValue));
    return type ? (
      <>
        {number}&nbsp;<span style={{ color: "#998CA6" }}>{type}</span>
      </>
    ) : (
      number
    );
  };

  const columns: ColumnsType<DataType> = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      width: 40,
    },
    {
      title: "Collection",
      dataIndex: "collection",
      key: "collection",
      align: "left",
      render: (collection) => <CollectionsCell collection={collection} />,
      width: 200,
    },
    {
      title: "Total Volume",
      dataIndex: "volume",
      key: "volume",
      align: "right",
      render: (text) => (
        <div
          style={{
            display: "flex",
            justifyContent: "right",
            fontWeight: 600,
          }}
        >
          {convertToInternationalCurrencySystem(text, TEXT_OPV)}
        </div>
      ),
      width: 150,
      sorter: (a, b) => Number(a.volume) - Number(b.volume),
    },
    {
      title: "Floor price",
      dataIndex: "price",
      key: "price",
      align: "right",
      render: (text) => (
        <div
          style={{
            display: "flex",
            justifyContent: "right",
            fontWeight: 600,
          }}
        >
          {convertToInternationalCurrencySystem(text, TEXT_OPV)}
        </div>
      ),
      width: 150,
      sorter: (a, b) => Number(a.price) - Number(b.price),
    },
    {
      title: "% Price Change",
      dataIndex: "volChange",
      key: "volChange",
      align: "right",
      render: (value) => (
        <div style={{ color: parseFloat(value) < 0 ? "#FE4134" : "#00c70a" }}>
          {value}%
        </div>
      ),
      width: 125,
      sorter: (a, b) => parseFloat(a.volChange) - parseFloat(b.volChange),
    },
    {
      title: "Owners",
      dataIndex: "owners",
      key: "owners",
      align: "right",
      render: (text) => convertToInternationalCurrencySystem(text, ""),
      width: 100,
    },
    {
      title: "Items",
      dataIndex: "items",
      key: "items",
      align: "right",
      render: (text) => convertToInternationalCurrencySystem(text, ""),
      width: 100,
    },
  ];

  const dataSource =
    dataTop?.data?.map((item: any, idx: number) => ({
      key: idx + 1,
      collection: {
        name: item?.displayName
          ? item?.displayName.length < 21
            ? item?.displayName
            : `${item?.displayName.slice(0, 20)}...`
          : item?.name.length < 21
          ? item?.name
          : `${item?.name.slice(0, 20)}...`,
        url: item?.logoUrl,
        id: item?.id,
        owner: item?.ownerAddress,
      },
      price: item?.floorPrice,
      volume: item?.volume?.value?.valueOPV,
      volChange: item?.volume?.changePercent,
      owners: item?.totalOwner,
      items: item?.totalNFT,
      isFavorite: item?.isFavorite,
    })) || [];

  return (
    <div className={styles.top_table}>
      {dataSource ? (
        <Table
          className={styles.table}
          columns={columns}
          dataSource={dataSource}
          scroll={{
            y:
              isPressSeeAll || dataSource.length < 10
                ? dataSource.length * CELL_HEIGHT
                : (dataSource.length / 2 + 2) * CELL_HEIGHT,
          }}
          pagination={false}
          showSorterTooltip={false}
        />
      ) : (
        <div className="flex flex-col items-center justify-center my-12 gap-y-4">
          <ReactLoading
            type="spin"
            color="rgba(0, 0, 0, 0.7)"
            height={32}
            width={32}
          />
        </div>
      )}
      {dataSource.length >= 10 && (
        <div
          className={styles.table_fog}
          style={{
            height: isPressSeeAll
              ? 0
              : (dataSource.length / 2 + 1) * CELL_HEIGHT + 10,
          }}
        />
      )}
      <Button
        className={styles.view_all_btn}
        onClick={() =>
          isPressSeeAll || dataSource.length < 10
            ? history.push(routes.RANKING)
            : setIsPressSeeAll(true)
        }
      >
        See all collection
      </Button>
    </div>
  );
};

export default TopTable;
